import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Tooltip } from 'components/core/Tooltip';

import './TooltipBanner.scss';

export function TooltipBanner({
	children,
	content,
	className,
	triggerAlignment = 'center',
	clickOnMobile = true,
	simpleButton = true,
	as = 'div',
	...tooltipProps
}) {
	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={content}
			clickOnMobile={clickOnMobile}
			fillParentContainer={triggerAlignment}
			simpleButton={simpleButton}
			as={as}
			{...tooltipProps}
		>
			{children}
		</Tooltip>
	);
}

TooltipBanner.propTypes = {
	children: PropTypes.node.isRequired,
	content: PropTypes.node.isRequired,
	className: PropTypes.string,
	triggerAlignment: PropTypes.string,
	clickOnMobile: PropTypes.bool,
	simpleButton: PropTypes.bool,
	as: PropTypes.string,
};

export default TooltipBanner;

